import styled from 'styled-components';
import { blue5 } from '@common/styles';
import { XHeaderDownload } from '@xiangxin-wc/react';

// 只取其 ws 消息监听能力（消息到达经 XNotify 直接挂 body 弹窗，不受宿主隐藏
// 影响），下载中心入口 UI 按需求不展示
export const HiddenHeaderDownload = styled(XHeaderDownload)`
  display: none;
`;

export const LayoutHeaderWrapper = styled.div`
  display: flex;
  padding: 0 26px;
  height: 60px;
  background: ${blue5};
`;

export const LayoutHeaderLead = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

export const LogoWrapper = styled.div`
  display: flex;
`;
export const SloganWrapper = styled.div`
  display: flex;
  margin-left: 18px;
`;

export const LogoImg = styled.img`
  height: 20px;
`;

export const SloganImg = styled.img`
  height: 16px;
`;

export const LayoutHeaderTail = styled.div`
  display: flex;
  align-items: center;
`;

export const UserInfoWrapper = styled.div`
  display: flex;
  margin-right: 20px;
  color: #fff;
`;

export const EnterpriseName = styled.span`
  margin-right: 20px;
`;

export const UserName = styled.span`
  margin-right: 20px;
`;

export const LogoutButton = styled.a`
  color: #fff;
`;

export const WeappWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
`;

export const WeappItemWrapper = styled.div`
  font-size: 16px;
`;
export const WeappItemImgWrapper = styled.img`
  display: block;
  width: 300px;
  margin-bottom: 20px;
`;

export const TextWrapper = styled.div`
  color: #1890ff;
  text-align: center;
`;
export const WeappPopoverText = styled.div`
  color: #fff;
  margin-right: 20px;
`;

export const NoticeBellWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
`;
